module.exports = {
     BASE_URL: BASE_URL,
     api: {
          gestion:{
               getHomeConfigCarouselImages: BASE_URL + "gestion/homeConfig/carrusel/",
               getHomeConfig:BASE_URL + "gestion/homeConfig/",
          },
          novedades:BASE_URL + "gestion/novedades/last/",
          infoofertas: BASE_URL + "api/ofertas/",
          ofertas: BASE_URL + "api/productos/ofertas/",
          ofertasrandom: BASE_URL + "api/productos/ofertas/random/",
          destacados: BASE_URL + "api/productos/destacados/",
          destacadosrandom:BASE_URL + "api/productos/destacados/random/",
          tiposdocumentos:BASE_URL + "api/tiposdocumentos/",
          search:BASE_URL + "api/search/",
          producto: BASE_URL + "api/producto/",
          productos: BASE_URL + "api/productos/",
          menu: BASE_URL + "api/menu/",
          pedidos: BASE_URL + "api/pedidos/",
          cart: BASE_URL + "api/cart/",
          generatecart: BASE_URL + "api/generatecart/@@/",
          pedidosGenerar: BASE_URL + "api/generarpedido/",
          random: BASE_URL + "api/random/productos/",
          auth: {
               login: BASE_URL + "auth/login/",
               logoff: BASE_URL + "auth/logoff/",
               check: BASE_URL + "auth/check/",
               profile: BASE_URL + "auth/profile/",
               recentqueries: BASE_URL + "auth/recentqueries/",
          },
          perfil:{
               editar:BASE_URL+'api/perfil/'
          },
          modoenvio: BASE_URL + "perfil/modoenvio/",
          formasdepago: BASE_URL + "api/formasdepago/",
          transportesAsociados:BASE_URL + "api/transportesAsociados/",
          provinciaslocalidades:BASE_URL + "api/provinciaslocalidades/",
          lastcartitem: BASE_URL + "perfil/lastCartItem/",
          setcartitem: BASE_URL + "perfil/saveCartItems/",
     }
}



// WEBPACK FOOTER //
// ./src/api/api.js